/* tslint:disable */
/* eslint-disable */
/**
 * PaGu Api
 * Gutschrifterstellung API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreditNoteProcessAutomatedStatusResponse } from '../models';
// @ts-ignore
import type { CreditNoteShortInfoResponseIPagedListResponse } from '../models';
// @ts-ignore
import type { CreditNotesByFilterRequest } from '../models';
// @ts-ignore
import type { ProblemDetails } from '../models';
// @ts-ignore
import type { ProcessAutomatedSetStatusRequest } from '../models';
/**
 * CreditNoteApi - axios parameter creator
 * @export
 */
export const CreditNoteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreditNotesByFilterRequest} [creditNotesByFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CreditnoteFilterPost: async (creditNotesByFilterRequest?: CreditNotesByFilterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/creditnote/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(creditNotesByFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CreditnoteProcessAutomatedPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/creditnote/process-automated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CreditnoteProcessAutomatedStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/creditnote/process-automated/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProcessAutomatedSetStatusRequest} [processAutomatedSetStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CreditnoteProcessAutomatedStatusPut: async (processAutomatedSetStatusRequest?: ProcessAutomatedSetStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/creditnote/process-automated/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processAutomatedSetStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CreditnoteTransferPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/creditnote/transfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreditNoteApi - functional programming interface
 * @export
 */
export const CreditNoteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CreditNoteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreditNotesByFilterRequest} [creditNotesByFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CreditnoteFilterPost(creditNotesByFilterRequest?: CreditNotesByFilterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditNoteShortInfoResponseIPagedListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CreditnoteFilterPost(creditNotesByFilterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditNoteApi.apiV1CreditnoteFilterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CreditnoteProcessAutomatedPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CreditnoteProcessAutomatedPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditNoteApi.apiV1CreditnoteProcessAutomatedPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CreditnoteProcessAutomatedStatusGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditNoteProcessAutomatedStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CreditnoteProcessAutomatedStatusGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditNoteApi.apiV1CreditnoteProcessAutomatedStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProcessAutomatedSetStatusRequest} [processAutomatedSetStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CreditnoteProcessAutomatedStatusPut(processAutomatedSetStatusRequest?: ProcessAutomatedSetStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CreditnoteProcessAutomatedStatusPut(processAutomatedSetStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditNoteApi.apiV1CreditnoteProcessAutomatedStatusPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CreditnoteTransferPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CreditnoteTransferPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditNoteApi.apiV1CreditnoteTransferPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CreditNoteApi - factory interface
 * @export
 */
export const CreditNoteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CreditNoteApiFp(configuration)
    return {
        /**
         * 
         * @param {CreditNotesByFilterRequest} [creditNotesByFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CreditnoteFilterPost(creditNotesByFilterRequest?: CreditNotesByFilterRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreditNoteShortInfoResponseIPagedListResponse> {
            return localVarFp.apiV1CreditnoteFilterPost(creditNotesByFilterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CreditnoteProcessAutomatedPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1CreditnoteProcessAutomatedPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CreditnoteProcessAutomatedStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<CreditNoteProcessAutomatedStatusResponse> {
            return localVarFp.apiV1CreditnoteProcessAutomatedStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProcessAutomatedSetStatusRequest} [processAutomatedSetStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CreditnoteProcessAutomatedStatusPut(processAutomatedSetStatusRequest?: ProcessAutomatedSetStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1CreditnoteProcessAutomatedStatusPut(processAutomatedSetStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CreditnoteTransferPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1CreditnoteTransferPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CreditNoteApi - interface
 * @export
 * @interface CreditNoteApi
 */
export interface CreditNoteApiInterface {
    /**
     * 
     * @param {CreditNotesByFilterRequest} [creditNotesByFilterRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditNoteApiInterface
     */
    apiV1CreditnoteFilterPost(creditNotesByFilterRequest?: CreditNotesByFilterRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreditNoteShortInfoResponseIPagedListResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditNoteApiInterface
     */
    apiV1CreditnoteProcessAutomatedPost(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditNoteApiInterface
     */
    apiV1CreditnoteProcessAutomatedStatusGet(options?: RawAxiosRequestConfig): AxiosPromise<CreditNoteProcessAutomatedStatusResponse>;

    /**
     * 
     * @param {ProcessAutomatedSetStatusRequest} [processAutomatedSetStatusRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditNoteApiInterface
     */
    apiV1CreditnoteProcessAutomatedStatusPut(processAutomatedSetStatusRequest?: ProcessAutomatedSetStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditNoteApiInterface
     */
    apiV1CreditnoteTransferPost(options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * CreditNoteApi - object-oriented interface
 * @export
 * @class CreditNoteApi
 * @extends {BaseAPI}
 */
export class CreditNoteApi extends BaseAPI implements CreditNoteApiInterface {
    /**
     * 
     * @param {CreditNotesByFilterRequest} [creditNotesByFilterRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditNoteApi
     */
    public apiV1CreditnoteFilterPost(creditNotesByFilterRequest?: CreditNotesByFilterRequest, options?: RawAxiosRequestConfig) {
        return CreditNoteApiFp(this.configuration).apiV1CreditnoteFilterPost(creditNotesByFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditNoteApi
     */
    public apiV1CreditnoteProcessAutomatedPost(options?: RawAxiosRequestConfig) {
        return CreditNoteApiFp(this.configuration).apiV1CreditnoteProcessAutomatedPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditNoteApi
     */
    public apiV1CreditnoteProcessAutomatedStatusGet(options?: RawAxiosRequestConfig) {
        return CreditNoteApiFp(this.configuration).apiV1CreditnoteProcessAutomatedStatusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProcessAutomatedSetStatusRequest} [processAutomatedSetStatusRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditNoteApi
     */
    public apiV1CreditnoteProcessAutomatedStatusPut(processAutomatedSetStatusRequest?: ProcessAutomatedSetStatusRequest, options?: RawAxiosRequestConfig) {
        return CreditNoteApiFp(this.configuration).apiV1CreditnoteProcessAutomatedStatusPut(processAutomatedSetStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditNoteApi
     */
    public apiV1CreditnoteTransferPost(options?: RawAxiosRequestConfig) {
        return CreditNoteApiFp(this.configuration).apiV1CreditnoteTransferPost(options).then((request) => request(this.axios, this.basePath));
    }
}

